import { isHSBCInstance } from '@ben/orion/utils/sub-domain';
import type { ThemeComponents } from '@ben/orion/theme-variations/components';
import { componentsHSBC } from '@ben/orion/theme-variations/components';
import GlobalCssCustomProperties from '@ben/orion/utils/css-modules/global-css-custom-properties';
import type { ITheme } from '@ben/orion/utils/theme';
import { theme as orionTheme } from '@ben/orion/utils/theme';
import type { ReactNode } from 'react';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';

interface UiColorsPalette {
  primary: {
    main: string;
    light: string;
    dark: string;
    bg: string;
  };
  secondary: {
    main: string;
    light: string;
    dark: string;
    bg: string;
  };
  components: ThemeComponents;
}

interface ThemeProviderProps {
  uiColorsPalette?: UiColorsPalette;
  children: ReactNode;
  isWhiteLabel?: boolean;
}

const ThemeProvider = ({
  uiColorsPalette,
  children,
  isWhiteLabel,
}: ThemeProviderProps) => {
  const { components, ...uiColorsPaletteRest } = uiColorsPalette ?? {};
  const fallbackLeftNavigation = isHSBCInstance
    ? componentsHSBC.leftNavigation
    : orionTheme.components.leftNavigation;
  const theme: ITheme = {
    ...orionTheme,
    palette: {
      ...orionTheme.palette,
      ...uiColorsPaletteRest,
    },
    components: {
      leftNavigation: {
        ...fallbackLeftNavigation,
        ...components?.leftNavigation,
      },
    },
    isWhiteLabel: isWhiteLabel ?? isHSBCInstance,
  };

  return (
    <StyledComponentsThemeProvider theme={theme}>
      <GlobalCssCustomProperties />
      {children}
    </StyledComponentsThemeProvider>
  );
};

export default ThemeProvider;
